module.exports = __webpack_public_path__ + "img/sprinkle-25.d4fedcd1.jpg";